import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' }
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/4ea35a69-073a-4757-842e-0e27ab0ba04d.png"
                alt="PINTORDECO HOSPITALET Logo"
                className="h-12 w-auto"
              />
              <div className="hidden sm:block">
                <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-[#0B3A53]' : 'text-white'}`}>
                  PINTORDECO HOSPITALET
                </span>
              </div>
            </Link>

            {/* Navigation Desktop */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-medium transition-colors hover:text-[#2EE6A6] cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-[#2EE6A6] font-bold'
                      : isScrolled
                      ? 'text-[#0F172A]'
                      : 'text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* CTA Button Desktop */}
            <div className="hidden lg:block">
              <a
                href="tel:+34690220944"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#2EE6A6] text-[#0F172A] rounded-full font-semibold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-lg"></i>
                Llamar ahora
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer ${
                isScrolled ? 'text-[#0F172A]' : 'text-white'
              }`}
              aria-label="Menú"
            >
              <span
                className={`block w-6 h-0.5 bg-current transition-transform ${
                  isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
                }`}
              ></span>
              <span
                className={`block w-6 h-0.5 bg-current transition-opacity ${
                  isMobileMenuOpen ? 'opacity-0' : ''
                }`}
              ></span>
              <span
                className={`block w-6 h-0.5 bg-current transition-transform ${
                  isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
              ></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setIsMobileMenuOpen(false)}
          ></div>
          <div className="absolute top-20 right-0 bottom-0 w-80 bg-white shadow-2xl overflow-y-auto">
            <nav className="p-6 space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-6 py-4 rounded-xl font-medium transition-all cursor-pointer ${
                    location.pathname === link.path
                      ? 'bg-[#E8F5F1] text-[#0B3A53] font-bold'
                      : 'text-[#0F172A] hover:bg-[#F6F7FB]'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
            <div className="p-6 border-t border-[#E2E8F0]">
              <a
                href="tel:+34690220944"
                className="block w-full text-center py-4 bg-[#2EE6A6] text-[#0F172A] rounded-full font-bold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Llamar ahora
              </a>
              <a
                href="https://wa.me/34690220944?text=Hola,%20necesito%20presupuesto"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center py-4 mt-3 bg-[#0B3A53] text-white rounded-full font-bold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;